import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { GlobalReactQueryOptions } from '../../config';
import { browserClient } from '../../react-query';
import { UseQueryResult } from '../query-types';
import { fetchCartSummary, FetchCartSummaryResponse } from '../listContent/fetchCartSummary';

const CART_SUMMARY_QUERY_KEY = 'cartSummary';

export type UseCartSummaryQuery = UseQueryResult<'data', FetchCartSummaryResponse>;

export const emptyCartSummary: FetchCartSummaryResponse = {
    comingSoonProductsAmount: 0,
    currency: '',
    eaudiobooksAmount: 0,
    eaudiobooksProductAmount: 0,
    eaudiobooksValue: 0,
    ebooksAmount: 0,
    ebooksProductAmount: 0,
    ebooksValue: 0,
    epressAmount: 0,
    epressProductAmount: 0,
    epressValue: 0,
    totalNetValue: 0,
    totalTaxValue: 0,
    totalValue: 0,
    unavailableProductsAmount: 0
};

export const useCartSummaryQuery = (): UseCartSummaryQuery => {
    const queryData = useQuery([CART_SUMMARY_QUERY_KEY], () => fetchCartSummary(), {
        ...GlobalReactQueryOptions
    });

    return useMemo(
        () => ({
            ...queryData,
            data: queryData.data ?? emptyCartSummary
        }),
        [queryData]
    );
};

export const invalidateCartSummaryQuery = () => {
    return browserClient.invalidateQueries({ queryKey: [CART_SUMMARY_QUERY_KEY] });
};
